const msJcamp = `
##TITLE= GC-MS analysis of Phenol, 2-Chlorphenol, and o-Kresol
##JCAMP-DX= 5.00   $$ ISAS JCAMP-DX program (V.1.0)
##DATA TYPE= MASS SPECTRUM
##DATA CLASS= NTUPLES
##ORIGIN= H. Mayer, ISAS Dortmund
##OWNER= COPYRIGHT (C) 1993 by ISAS Dortmund, FRG
##SPECTROMETER/DATA SYSTEM= Finnigan MAT Magnum
##.SPECTROMETER TYPE= TRAP
##.INLET= GC
##.IONIZATION MODE= EI+
##$CSSCANAUTOTARGET= 2
##$CSSCANEDITTARGET= 3
##$CSSCANCOUNT= 5
##$CSTHRESHOLD= 0.07
##NTUPLES= MASS SPECTRUM
##VAR_NAME= MASS, INTENSITY, RETENTION TIME,
##SYMBOL= X, Y, T
##VAR_TYPE= INDEPENDENT, DEPENDENT, INDEPENDENT
##VAR_FORM= AFFN, AFFN, AFFN
##VAR_DIM= , , 3
##UNITS= M/Z, RELATIVE ABUNDANCE, SECONDS
##FIRST= , , 272
##LAST= , , 333
##PAGE= T= 272
##NPOINTS= 18
##DATA TABLE= (XY..XY), PEAKS
50, 2.52; 51, 9.32; 52, 7.42; 53, 1.30; 54, 5.46; 61, 4.07
62, 5.46; 63, 11.17; 64, 2.52; 65, 39.72; 66, 63.70; 67, 4.13
68, 1.22; 77, 1.89; 79, 1.63; 93, 2.13; 94, 100.00; 95, 8.09
##PAGE= T= 301
##NPOINTS= 26
##DATA TABLE= (XY..XY), PEAKS
50, 5.84; 51, 9.55; 52, 4.19; 53, 1.12; 54, 12.67; 60, 3.80
61, 10.16; 62, 13.47; 63, 58.30; 64, 60.43; 65, 33.02; 66, 4.32
72, 1.70; 75, 1.62; 91, 1.03; 92, 24.95; 93, 4.20; 94, 1.25
99, 7.20; 100, 19.83; 101, 3.45; 102, 6.47; 128, 100.00; 129, 6.52
130, 32.45; 131, 2.13
##PAGE= T= 333
##NPOINTS= 26
##DATA TABLE= (XY..XY), PEAKS
50, 3.93; 51, 22.60; 52, 29.96; 53, 12.27; 54, 19.93; 55, 4.24
56, 3.64; 61, 3.55; 62, 5.12; 63, 14.49; 64, 2.36; 65, 4.70
66, 2.57; 68, 1.25; 76, 1.57; 77, 53.08; 78, 12.56; 79, 64.79
80, 30.92; 81, 4.33; 90.01221, 50.26; 90.01222, 54.82; 90.01223, 59.30; 107, 91.80
108, 100.00; 109, 8.55
##PAGE= T= 410
##NPOINTS= 5
##DATA TABLE= (XY..XY), PEAKS
30, 100; 55, 150; 70, 200; 75, 220; 100, 50;
##PAGE= T= 550
##NPOINTS= 5
##DATA TABLE= (XY..XY), PEAKS
30, 400; 55, 200; 70, 180; 75, 160; 100, 50;
##END NTUPLES= MASS SPECTRUM
##END=
`;

export default msJcamp;
